import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-sports.svg";
import * as styles from "./Icon.module.scss";

type SportsProps = React.SVGProps<SVGSVGElement>;

export const Sports = ({ className, ...props }: SportsProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
